import {createStyles, Theme} from "@material-ui/core";
import {styleColors, typography} from "src/main.style";

export const PopupStyle = (theme: Theme) => createStyles({
  popUpMenu : {
    display:'flex', 
    flexDirection:'column', 
    padding: '8px 0px'
  }, /*
  popUpMenuArrow : {
    position: 'absolute',
    right: '50%',
    left: '50%',
    top: '-5px', // Adjust this value to position the triangle 
    width: 0,
    height: 0,
    borderLeft: `5px solid ${styleColors.transparent}`, // Adjust the size of the triangle 
    borderRight: `5px solid ${styleColors.transparent}`, // Adjust the size of the triangle 
    borderBottom: `5px solid ${styleColors.white}`, // Adjust the color of the triangle 
    transform: 'translateX(-50%)', // Center the triangle vertically 
  }, */
  menuListItem: {
    ...typography.input,
  },
  menuItemEnd : {
    opacity: 0.7,
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  handoverDetails: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    marginTop: '2px',
    fontSize: '14px',
    fontWeight: 400,
    color: styleColors.greyDark1,
    minWidth: 0,
  },
  handoverDetail: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    whiteSpace: 'nowrap',
  },
  handoverPlace: {
    minWidth: 0,
    flex: '0 1 auto',
  },
  handoverPlaceText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  handoverDetailIcon: {
    fontSize: '16px',
    flexShrink: 0,
    color: styleColors.greyMedium2,
  },
  holidayTitle: {
    display: "flex",
    alignItems: "center",
    fontSize: "16px",
    fontWeight: "bold",
    marginLeft: "10px",
    
  }
});


// WEBPACK FOOTER //
// ./src/components/calendar2/monthView/popup.style.ts